import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["accountId"];
import UISelect from 'UIComponents/input/UISelect';
import { useHubSpotterUsersForAccount } from '..';
import formatName from 'I18n/utils/formatName';
import { useEffect, useRef } from 'react';
import Raven from 'raven-js';
import { createElement as _createElement } from "react";
const generateOptions = usersForAccount => {
  return usersForAccount ? usersForAccount.results.map(user => ({
    text: formatName({
      firstName: user.firstName,
      lastName: user.lastName
    }),
    value: user.userId
  })) : [];
};
const PAGE_SIZE = 20;
export const HubSpotterAccountUsersSelect = _ref => {
  let {
      accountId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    usersForAccountLoading,
    refetchUsersForAccount
  } = useHubSpotterUsersForAccount({
    accountId
  });
  const accumulatedResults = useRef([]);
  useEffect(() => {
    accumulatedResults.current = [];
  }, [accountId]);
  return /*#__PURE__*/_createElement(UISelect, Object.assign({}, props, {
    isLoading: usersForAccountLoading
    // Reset the state when the account changes and we want to load new users
    ,
    key: accountId,
    loadOptions: async (query, callback, pagination = {
      offset: 0
    }) => {
      try {
        const newUsers = await refetchUsersForAccount({
          query,
          offset: pagination.offset
        });
        const newResults = [...accumulatedResults.current, ...generateOptions(newUsers)];
        accumulatedResults.current = newResults;
        callback(null, {
          options: newResults,
          pagination: {
            hasMore: newUsers.hasMore,
            length: newUsers.total,
            offset: pagination.offset + PAGE_SIZE
          }
        });
      } catch (e) {
        Raven.captureException(e);
      }
    },
    multi: true
  }));
};